import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useState, useCallback } from 'react';
import getInitialValues from "./getInitialValues";

var useSettigs = function useSettigs(_ref) {
  var groups = _ref.groups,
      getSettings = _ref.getSettings,
      applySetting = _ref.applySetting;

  var _useState = useState(getSettings),
      _useState2 = _slicedToArray(_useState, 2),
      values = _useState2[0],
      setValues = _useState2[1];

  var setValue = useCallback(function (property, value) {
    applySetting(property, value);
    setValues(function (currentValues) {
      return _objectSpread({}, currentValues, _defineProperty({}, property, value));
    });
  });
  var handleRestore = useCallback(function () {
    var initialSettings = getInitialValues(groups);
    Object.keys(initialSettings).forEach(function (property) {
      applySetting(property, initialSettings[property]);
    });
    setValues(initialSettings);
  }, [groups]);
  return {
    values: values,
    setValue: setValue,
    handleRestore: handleRestore
  };
};

export default useSettigs;